import { render, staticRenderFns } from "./PromoterList.vue?vue&type=template&id=af157a80&"
import script from "./PromoterList.vue?vue&type=script&lang=js&"
export * from "./PromoterList.vue?vue&type=script&lang=js&"
import style0 from "./PromoterList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports